"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeycloakSessionService = void 0;
var keycloak_1 = require("@unitedtraders/keycloak");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var CookieKeys;
(function (CookieKeys) {
    CookieKeys["FirstLoginAt"] = "firstLoginAt";
    CookieKeys["WasLoginedIn"] = "wasLoginedIn";
})(CookieKeys || (CookieKeys = {}));
var KeycloakSessionService = /** @class */ (function () {
    function KeycloakSessionService(config, cookieManager, domain, getLogger) {
        var _this = this;
        this.config = config;
        this.cookieManager = cookieManager;
        this.domain = domain;
        this.getTokens = function () {
            return _this.keycloak.getTokens();
        };
        this.refreshTokens = function () { return __awaiter(_this, void 0, void 0, function () {
            var refreshToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keycloak.getTokens()];
                    case 1:
                        refreshToken = (_a.sent()).refreshToken;
                        return [2 /*return*/, this.keycloak.refreshTokens(refreshToken)];
                }
            });
        }); };
        this.removeTokensFromStorage = function () {
            _this.keycloak.removeTokensFromStorage();
        };
        this.logout = function () {
            _this.keycloak.logout();
        };
        this.logger = getLogger("SessionService");
        var tokensSubject = new rxjs_1.Subject();
        var storage = new keycloak_1.CookieStorage({
            domain: this.domain,
            accessTokenName: "access_token",
            refreshTokenName: "refresh_token",
        }, getLogger("SessionServiceCookieStorage"));
        this.keycloak = new keycloak_1.Keycloak(this.config, undefined, storage);
        this.keycloak
            .getTokens()
            .then(function (tokens) {
            tokensSubject.next(tokens);
        })
            .catch(function (e) {
            tokensSubject.next(undefined);
            _this.logger.debug("Tokens not found", e);
        });
        this.keycloak.on("remove:tokens", function () {
            tokensSubject.next(undefined);
        });
        this.keycloak.on("change:tokens", function (tokens) {
            tokensSubject.next(tokens);
        });
        this.tokens = tokensSubject.pipe(operators_1.shareReplay(1));
        this.isAuthorized.pipe(operators_1.filter(function (isAuthorized) { return isAuthorized === true; }));
        this.isAuthorized.subscribe(function (isAuthorized) {
            if (isAuthorized && !_this.cookieManager.get(CookieKeys.WasLoginedIn)) {
                cookieManager.set(CookieKeys.WasLoginedIn, "true", {
                    expires: 1000,
                });
            }
        });
        if (typeof window !== "undefined") {
            this.keycloak.startAutoRefresher();
            this.keycloak.startLogoutWatcher();
        }
    }
    KeycloakSessionService.prototype.getKeycloak = function () {
        return this.keycloak;
    };
    Object.defineProperty(KeycloakSessionService.prototype, "isAuthorized", {
        get: function () {
            return rxjs_1.concat(rxjs_1.of(undefined), this.tokens.pipe(operators_1.map(function (tokens) {
                return !!tokens;
            }))).pipe(operators_1.distinctUntilChanged(), operators_1.shareReplay(1));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakSessionService.prototype, "firstLoginedAt", {
        // @deprecated
        get: function () {
            var ts = this.cookieManager.get(CookieKeys.FirstLoginAt);
            return ts ? new Date(ts) : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakSessionService.prototype, "wasLoginedIn", {
        get: function () {
            return (Boolean(this.cookieManager.get(CookieKeys.WasLoginedIn)) ||
                Boolean(this.cookieManager.get(CookieKeys.FirstLoginAt)));
        },
        enumerable: false,
        configurable: true
    });
    KeycloakSessionService.prototype.setTokens = function (tokens) {
        this.keycloak.setTokens(tokens);
    };
    return KeycloakSessionService;
}());
exports.KeycloakSessionService = KeycloakSessionService;
//# sourceMappingURL=KeycloakSessionService.js.map